import { render, staticRenderFns } from "./addTempAreaTemplate.vue?vue&type=template&id=01257666&scoped=true&"
import script from "./addTempAreaTemplate.vue?vue&type=script&lang=js&"
export * from "./addTempAreaTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01257666",
  null
  
)

export default component.exports